import LoopIcon from '@mui/icons-material/Loop';
import { Step } from '../../components/Step';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Checkboxes } from 'mui-rff';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Table } from 'src/shared/components/Table/Table';
import { type IntegrationParamOption } from 'src/shared/api/integrations/common';
import { type DataTableRow, useColumnsV2 } from '../../utils/constants';

enum COLUMN_FIELD_NAMES {
  PAYROLL_CODE = 'payrollCode',
  DOCUMENT_NUMBER = 'documentNumber',
  EMAIL = 'email',
  CONTRACT_PHONE = 'phone',
  BANK_ACCOUNT_NUMBER = 'accountNumber',
  GROSS_SALARY = 'grossSalary'
}

const columnFieldLabel: Record<COLUMN_FIELD_NAMES, string> = {
  [COLUMN_FIELD_NAMES.PAYROLL_CODE]: 'table.payroll id',
  [COLUMN_FIELD_NAMES.DOCUMENT_NUMBER]: 'table.document number',
  [COLUMN_FIELD_NAMES.EMAIL]: 'table.email',
  [COLUMN_FIELD_NAMES.CONTRACT_PHONE]: 'table.mobile',
  [COLUMN_FIELD_NAMES.BANK_ACCOUNT_NUMBER]: 'table.iban',
  [COLUMN_FIELD_NAMES.GROSS_SALARY]: 'table.monthly gross remuneration'
};

const dataTable: DataTableRow[] = Object.values(COLUMN_FIELD_NAMES).map(fieldName => ({
  fieldInPayflow: {
    label: columnFieldLabel[fieldName],
    value: fieldName
  }
}));

type Step6Props = {
  customFields: IntegrationParamOption[];
};

export const Step6 = ({ customFields }: Step6Props) => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();
  const columns = useColumnsV2('Personio', customFields ?? []);

  return (
    <Step
      title={`${t('integrations.step')} 6`}
      subtitle={`${t('If you use custom fields', { softwareName: 'Personio' })}:`}
      Icon={LoopIcon}
    >
      <>
        <Grid2 xs={12}>
          <Checkboxes
            name="withCustomFields"
            data={{ label: t('use custom fields', { ns: 'settings' }), value: true }}
          />
        </Grid2>

        {values?.withCustomFields && <Table rows={dataTable} columns={columns} />}
      </>
    </Step>
  );
};
